import MicroModal from 'micromodal';

export const initContacts = () => {
  MicroModal.init();

  // $('.contacts-privacy__link--privacypolicy').on('click', e => {
  //   e.preventDefault();
  //   MicroModal.show('privacypolicy');
  // });

  $('.contacts-form__controls').on('submit', function(e) {
    e.preventDefault();
    const $this = $(this);
    const data = $(this).serialize();

    $.ajax({
      url: '/sendEmail',
      type: "POST",
      data,
      withCredentials: true,
      beforeSend(){
        $this.children('.btn--submit').attr('disabled', true);
      },
      success() {
        MicroModal.show('contacts-form-success');
      },
      error() {
        MicroModal.show('contacts-form-error');
      },
      always() {
        $this.children('.btn--submit').attr('disabled', false);
      }
    })
  });
};
